import React from "react";

// example: var one_rep_max = get1RepMax(metric_a, metric_b);

export const get1RepMax = (metric_a_val, metric_b_val) => {
    var percent1rm;
    var rep_max;

    //console.log("1 RM via % of MAX >>>>>>>> " + metric_b_val);
//    if(measure_position === "measure_a") {
        percent1rm = getPercent1RM(metric_b_val); // metric_b = reps
        rep_max    = (metric_a_val/percent1rm).toFixed(2);

    //    console.log("percent1rm: " + percent1rm);
/*    } else {
        percent1rm = getPercent1RM(metric_a_val); // metric_a = reps
        rep_max    = (metric_b_val/percent1rm).toFixed(2);
    }*/

    return rep_max;
}

export const getPercent1RM = (reps) => {
    var percent = 0;

    switch(parseInt(reps)) {
        case 1:
            percent = 1;
            break;
        case 2:
            percent = .95;
            break;
        case 3:
            percent = .93;
            break;
        case 4:
            percent = .90;
            break;
        case 5:
            percent = .87;
            break;
        case 6:
            percent = .85;
            break;
        case 7:
            percent = .83;
            break;
        case 8:
            percent = .80;
            break;
        case 9:
            percent = .77;
            break;
        case 10:
            percent = .75;
            break;
        case 11:
            percent = .73;
            break;
        case 12:
            percent = .70;
            break;
        case 13:
            percent = .67;
            break;
        case 14:
            percent = .65;
            break;
        default:
            percent = .60;
    }
    return percent;
}



// WEBPACK FOOTER //
// ./src/utils/OneRM.js